import { action } from 'typesafe-actions';
import {
  MARKETS_FAILURE,
  MARKETS_REQUEST,
  MARKETS_SUCCESS,
} from '../../constants/markets';

export const marketsRequestAction = () => action(MARKETS_REQUEST);
export const marketsSuccessAction = (data: any) =>
  action(MARKETS_SUCCESS, data);
export const marketsFailureAction = (e: any) => action(MARKETS_FAILURE, e);

export const marketsActions = {
  marketsRequestAction,
  marketsSuccessAction,
  marketsFailureAction,
};
